// extracted by mini-css-extract-plugin
module.exports = {"modal":"jgp-1LlWW","closeButton":"jgp-SnHyW","title":"jgp-1fvFu","description":"jgp-38waJ"};